import utils from '@eitje/utils'
import {docs} from '~/config'
import {EitjeButton} from '~/components'
import {PopoutHeader} from '../popout_header'
import {PopoutBody} from '../popout_body'
import {PopoutFooter} from '../popout_footer'
import {LegendBody} from './legend_body'

export const PopoutContent = ({type, ...rest}) => {
	switch (type) {
		case 'docs':
		case 'legend': {
			// docs and legend share the same interface, but the legend has a different title and body
			return <DocsContent {...rest} legend={type === 'legend'} />
		}
		case 'confirm':
			return <ConfirmContent {...rest} />
		case 'delete':
			return <DeleteContent {...rest} />
		default:
			return <BaseContent {...rest} />
	}
}

const BaseContent = ({title, titleLayoutProps, body, footer, footerButtonProps, footerButtons, showContentBorders}) => {
	const buttons = [...utils.alwaysArray(footerButtons), footerButtonProps && <EitjeButton {...footerButtonProps} />].filter(Boolean)

	return (
		<>
			<PopoutHeader title={title} layoutProps={titleLayoutProps} showContentBorders={showContentBorders} />
			<PopoutBody body={body} showContentBorders={showContentBorders} />
			<PopoutFooter footer={footer} buttons={buttons} showContentBorders={showContentBorders} />
		</>
	)
}

const DocsContent = ({docsId, collection, legend, items, title, body, ...rest}) => {
	const condOpts = docs?.useDocsLink({collection, to: docsId}) || {}

	const footerButtonProps = {
		t: 'common.explanation',
		className: 'docs-button',
		'data-intercom-target': 'docs_button',
		colorSet: 'solid',
		baseColor: 'pink',
		...condOpts,
	}

	let titleLayoutProps = {}

	if (legend) {
		titleLayoutProps = {borderBottom: true, padding: 12}
		body = <LegendBody items={items} />
	}

	return <BaseContent {...rest} title={title} titleLayoutProps={titleLayoutProps} body={body} footerButtonProps={footerButtonProps} />
}

const ConfirmContent = ({title, body, onConfirm, confirmButtonProps = {}, ...rest}) => {
	const _title = {t: 'popouts.confirm.title', ...title}
	const _body = {t: 'popouts.confirm.text', ...body}

	const footerButtonProps = {
		t: 'submit',
		iconLeft: 'checked',
		baseColor: 'blue',
		colorSet: 'solid',
		onClick: onConfirm,
		...confirmButtonProps,
	}

	return <BaseContent title={_title} body={_body} footerButtonProps={footerButtonProps} {...rest} />
}

const DeleteContent = ({title, body, onDelete, deleteButtonProps = {}, nonDestructive, ...rest}) => {
	const _title = {t: 'popouts.delete.title', ...title}
	const _body = {t: nonDestructive ? 'popouts.delete.non_destructive_text' : 'popouts.delete.text', ...body}

	const footerButtonProps = {
		t: 'delete',
		iconLeft: 'trash',
		baseColor: 'red',
		colorSet: 'solid',
		onClick: onDelete,
		...deleteButtonProps,
	}

	return <BaseContent title={_title} body={_body} footerButtonProps={footerButtonProps} {...rest} />
}
